<script setup lang="ts">
import { GpCard } from '@gportal/uikit';
import { type Datacenter, DatacenterStatus } from 'gpcore-grpc/gpcore/api/cloud/v1/region_pb';
import { computed } from 'vue';
import DatacenterItemContent from './DatacenterItemContent.vue';

const props = withDefaults(
  defineProps<{
    datacenter: Datacenter;
    isSelected?: boolean;
    latency?: number;
    isAllDatacentersAvailable?: boolean;
  }>(),
  {
    isSelected: false,
    latency: null,
    isAllDatacentersAvailable: false,
  },
);

const emit = defineEmits<{ (e: 'datacenterSelected') }>();

const isDatacenterComingSoon = computed(
  () => props.datacenter.status === DatacenterStatus.COMING_SOON,
);

const handleClick = () => {
  emit('datacenterSelected');
};
</script>
<template>
  <GpCard
    v-if="isDatacenterComingSoon"
    :enlarge-on-hover="false"
    @click="handleClick"
    class="tw-pointer-events-none tw-border-transparent tw-opacity-70"
    :aria-selected="isSelected"
  >
    <div
      class="tw-absolute tw-inset-x-0 tw-top-0 tw-h-5 tw-w-auto tw-rounded-t tw-bg-gp-rhino tw-text-center tw-text-xs tw-font-bold tw-uppercase tw-text-black"
    >
      Coming Soon
    </div>

    <DatacenterItemContent class="tw-pt-8" :datacenter="datacenter" :latency="latency" />
  </GpCard>

  <GpCard
    v-else
    :class="{
      'tw-cursor-pointer': !isSelected,
    }"
    :enlarge-on-hover="false"
    border-on-hover
    :active="isSelected"
    @click="handleClick"
    :aria-selected="isSelected"
  >
    <DatacenterItemContent
      :class="isAllDatacentersAvailable ? 'tw-pt-4' : 'tw-pt-8'"
      :datacenter="datacenter"
      :latency="latency"
    />
  </GpCard>
</template>
